import { useState, useEffect } from "@wordpress/element";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import { useFormContext } from "react-hook-form";
import FormHelperText from "@mui/material/FormHelperText";
import get from "lodash/get";
import range from "lodash/range";
import moment from "moment";
import SelectField from "../Select";

const months = moment.monthsShort().map((month, index) => ({
	label: month,
	value: index + 1,
}));

const DobField = ({ name }) => {
	const [date, setDate] = useState({
		day: "",
		month: "",
		year: "",
	});

	const [days, setDays] = useState([]);
	const [years, setYears] = useState([]);
	const { formState, setValue, watch } = useFormContext();
	const { errors } = formState;
	const error = get(errors, name);
	const dob = watch(name);

	useEffect(() => {
		setYears(getYears());
	}, []);

	useEffect(() => {
		if (dob) {
			const dt = moment(dob, "YYYY-MM-DD");
			const month = dt.month() + 1;
			setDate({
				day: dt.day(),
				month,
				year: dt.year(),
			});
			setDays(getDays(month));
		}
	}, [dob]);

	const handleMonthChange = (event) => {
		const { value } = event.target;
		setDays(getDays(value));
		const newState = { ...date, month: value };
		setDate(newState);
		setFullDate(newState);
	};

	const handleChange = (event) => {
		const { value, name } = event.target;
		const newState = { ...date, [name]: value };
		setDate(newState);
		setFullDate(newState);
	};

	const setFullDate = (date) => {
		const { day, month, year } = date;
		if (day && month && year) {
			setValue(name, `${year}-${month}-${day}`);
		}
	};

	return (
		<div className="flex flex-col">
			<InputLabel error={Boolean(error?.message)} htmlFor="dob">
				Date of birth *
			</InputLabel>
			<div className="grid grid-rows-1 grid-cols-3 gap-4" name="dob">
				<SelectField
					name="month"
					value={date.month}
					onChange={handleMonthChange}
				>
					{months.map((month) => (
						<MenuItem value={month.value} key={month.value}>
							{month.label}
						</MenuItem>
					))}
				</SelectField>
				<SelectField name="day" value={date.day} onChange={handleChange}>
					{days.map((day) => (
						<MenuItem value={day} key={day}>
							{day}
						</MenuItem>
					))}
				</SelectField>
				<SelectField name="year" value={date.year} onChange={handleChange}>
					{years.map((year) => (
						<MenuItem value={year} key={year}>
							{year}
						</MenuItem>
					))}
				</SelectField>
			</div>
			{Boolean(error) && (
				<FormHelperText error>{error?.message}</FormHelperText>
			)}
		</div>
	);
};

export default DobField;

const getDays = (month) => {
	const year = moment().year();
	const days = moment(`${month}-${year}`, "MM-YYYY").daysInMonth();
	return range(1, days + 1);
};

const getYears = () => {
	const startYear = moment().year() - 100;
	const endYear = moment().year();
	return range(startYear, endYear + 1);
};
